import { render, staticRenderFns } from "./highlightMenu.vue?vue&type=template&id=6d67d86e&scoped=true"
import script from "./highlightMenu.vue?vue&type=script&lang=js"
export * from "./highlightMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d67d86e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d67d86e')) {
      api.createRecord('6d67d86e', component.options)
    } else {
      api.reload('6d67d86e', component.options)
    }
    module.hot.accept("./highlightMenu.vue?vue&type=template&id=6d67d86e&scoped=true", function () {
      api.rerender('6d67d86e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/highlightMenu.vue"
export default component.exports